const HIGHLIGHT_KEYFRAMES = [
  { backgroundColor: 'rgba(250, 204, 21, 0.45)' },
  { backgroundColor: 'transparent' }
]

export function revealSelectedListItem (button, { prefersReducedMotion = false } = {}) {
  const listItem = button?.closest('li')
  if (!listItem) return null

  listItem.scrollIntoView({
    block: 'nearest',
    behavior: prefersReducedMotion ? 'auto' : 'smooth'
  })

  if (!prefersReducedMotion && typeof listItem.animate === 'function') {
    listItem.animate(HIGHLIGHT_KEYFRAMES, { duration: 900, easing: 'ease-out' })
  }

  return listItem
}
